<template>
  <div class='image'></div>
</template>

<script>
export default {
  name: 'RightPanel'
}
</script>

<style lang="scss" scoped>
.image {
  background-image: url('../../../assets/login-background.png');
  height: 100vh;
  width: 50%;
  background-repeat: no-repeat; 
  background-size: cover;
}
</style>
